export { default } from "./resolveProps.mjs";